/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon16Regular = forwardRef('FlagAIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 15a.75.75 0 0 0 1.5 0v-4.25H14.5a.75.75 0 0 0 .6-1.2L12.438 6 15.1 2.45a.75.75 0 0 0-.6-1.2H4A1.75 1.75 0 0 0 2.25 3v12ZM4 2.75a.25.25 0 0 0-.25.25v6.25H13l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8H4Z" })));
});
